import { createAction } from '@lingoda/core';
import type { ClassLeadTimeSchema } from '../models';

export default createAction<ClassLeadTimeSchema>('booking/ADD_LEAD_TIME');
